import { Button } from '@neo/primitives/button'
import { FileQuestion } from 'lucide-react'
import { useLocation } from 'router-v6'
import { getDefaultRoute } from 'v2/configs/routes'
import { useAppNavigate } from 'v2/shared/hooks/use-app-navigate'

export const NotFoundPage = () => {
  const location = useLocation()
  const navigate = useAppNavigate()

  return (
    <div className="flex h-full items-center justify-center overflow-y-auto p-6">
      <div className="flex w-full max-w-sm flex-col items-start gap-6">
        <div className="flex size-12 items-center justify-center rounded-lg border border-st2 bg-bg2">
          <FileQuestion className="size-6 text-secondary" aria-hidden="true" />
        </div>
        <div className="flex flex-col gap-3">
          <p className="font-jetbrains text-label uppercase text-tertiary">Error 404</p>
          <h1 className="text-h1-500 text-primary">Page not found</h1>
          <p className="text-p-400 text-secondary">
            This page may have moved, or the link may be incorrect. Check the address or return
            home.
          </p>
        </div>
        {location.pathname !== '/404' && (
          <div className="w-full border-t border-st2 pt-6">
            <Button
              size="sm"
              data-testid="button-take-me-home"
              onClick={() => navigate(getDefaultRoute())}
            >
              Take me home
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
